import { render, staticRenderFns } from "./AdjustLabelDialog.vue?vue&type=template&id=755b4de0&"
import script from "./AdjustLabelDialog.vue?vue&type=script&lang=js&"
export * from "./AdjustLabelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports